<template>
    <v-card style="background-color: #efeded; height: 100%">
        <v-card-text>
            <v-row>
                <v-col><v-icon @click="isColorPickerOpen = !isColorPickerOpen" color="primary">mdi-brush-outline</v-icon>
                    
                </v-col>
                <v-col class="text-left">
                    <v-btn-toggle v-model="selectedChart"
                                  shaped
                                  mandatory>
                        <v-btn value="chart1">
                            {{$t('ChartOne')}}
                        </v-btn>

                        <v-btn value="chart2">
                            {{$t('ChartTwo')}}
                        </v-btn>

                        <v-btn value="chart3">
                            {{$t('ChartThree')}}
                        </v-btn>
                    </v-btn-toggle>
                </v-col>
            </v-row>
           
            <!-- Color Picker Dialog -->
            <v-dialog v-model="isColorPickerOpen" max-width="400">
                <v-card>
                    <div class="card-title">
                        {{ $t('ChangeColor')}}
                    </div>
                    <v-card-title></v-card-title>
                    <v-card-text>
                        <v-color-picker v-model="chartColor" mode="hexa" />
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer />
                        <v-btn color="primary" text @click="isColorPickerOpen = false">
                            {{$t('Close')}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

        </v-card-text>

        <v-card-text v-if="selectedChart === 'chart1'" style="margin-top: 40px;">
            <ul class="mx-5">
                <li v-for="(item, index) in value.filter(x=>x.value>0)" :key="index" style="list-style:disc">
                    <div class="chart-item">
                        <div style="width:420px; font-size: 19px; color: #000;">{{ item.name }}</div>
                        <div class="chart-bar" :style="{ width: item.value + '%', backgroundColor:chartColor }"><div style="width:100px; font-size: 20px; color: #000;">{{ item.value }}%</div></div>
                    </div>
                </li>
            </ul>
        </v-card-text>
        <v-card-text v-if="selectedChart === 'chart2'">
            <template>
                <v-container class="d-flex justify-center align-center" style="min-height: 350px;max-height:unset;height:auto">
                    <v-row>
                        <v-col class="col-4" v-for="(item, index) in value.filter(x=>x.value>0)" :key="index">
                            <v-card class="text-center mb-4"
                                    elevation="3"
                                    width="180px" height="180px"
                                    style="width: 100%;border-radius: 15px; padding: 16px; position: relative;">
                                <div :style="`position: absolute; top: -30px; left: 50%; transform: translateX(-50%); width: 60px; height: 60px; border-radius: 50%; background-color: ${chartColor};`"><div :style="`font-size: 21px; color: white; margin-top: 16px;position:absolute;bottom:18px;width:100%;text-align:center`">{{item.value}}%</div></div>
                                <div class="d-flex justify-center align-center" style="height: 100%;">
                                    <p style="font-size: 21px; margin: 0; color: rgb(0, 0, 0)">{{item.name}}</p>
                                </div>
                            </v-card>
                        </v-col>
                    </v-row>

                </v-container>
            </template>
        </v-card-text>
        <v-card-text class="align-center" v-if="selectedChart === 'chart3'" >
            <table>
                <tr>
                    <td v-for="(item, index) in value.filter(x=>x.value>0)" :key="index">
                        <div class="vertical-bar" style="font-size: 21px;">
                            <div class="barcontainer" :style="{ height: item.value + '%', backgroundColor:chartColor }">{{ item.value }}%<div class="bar"></div></div>
                        </div>
                        <div class="barname" style="font-size: 21px; color: #000;"><span>{{ item.name }}</span></div>
                    </td>
                </tr>
            </table>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        props: {
            value: {
                type: Array,
                default: () => [],
            },

        },
        data() {
            return {

                selectedChart: 'chart1', // Default to horizontal view
                isColorPickerOpen: false, // Controls the dialog visibility
                chartColor: '#00bcd4', // Default chart color
            }
        }
    }
</script>

<style scoped>
.v-application .py-4 {
    color: #000;
}
    .chart-card {
        width: 30%;
        padding: 16px;
        background-color: #f5f5f5;
        border-radius: 8px;
    }

    .chart-title {
        background-color: #00bcd4;
        color: white;
        padding: 8px;
        border-radius: 4px;
        text-align: center;
    }

    .chart-item {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-bottom: 8px;
    }

    .chart-bar {
        height: 35px;
        line-height: 35px;
        color: white;
        text-align: right;
        padding-right: 8px;

        min-width: 0px;
    }

    .vertical-bar {
        display: flex;
        flex-direction: column;
        align-items: center;
        height: 120px;
        position: relative;
        margin:0 10px;
        width:50px;
    }

    .barcontainer {
        position: absolute;
        bottom: 50px;
        text-align: center;
    }

    .barname {
        position1: absolute;
        bottom1: 0px;
        width:110px;
        word-wrap:break-word;
        height:100px;
    }
        .barname span {
            display: block;
            transform: rotate(-60deg);
            width: 200px !important;
            margin-top: 60px;
            margin-right: -30px;
            height: 10px;
        }

    .bar {
        width: 50px;
        height: 100%;
        color: white;
        text-align: center;
    }

    .titlebackground {
        background-image: url('/public/titlebackground.png');
        background-repeat: no-repeat;
        height: 51px;
        background-size: contain;
        width: 100%;
        color: white;
        padding: 0 10px;
        line-height: 51px;
        background-position: right
    }
</style>
